// MainLayout.js
import React, { useState } from 'react';
import { AppLayout, Box, Alert } from '@cloudscape-design/components';
import { TopNav, SideNav, Breadcrumbs } from '../helpers/navigation';
import { ErrorProvider, useError } from '../helpers/errorContext';

const AlertComponent = () => {
  const { error, clearError } = useError();

  if (!error) return null;

  return (
    <Box padding="l">
      <Alert
        type="error"
        header="Error"
        dismissible
        onDismiss={clearError}
      >
        {error}
      </Alert>
    </Box>
  );
};

function MainLayout({ signOut, user, children }) {
  // Add this state declaration
  const [navigationOpen, setNavigationOpen] = useState(true);
  
  return (
    <div style={{ display: 'flex', flexDirection: 'column', height: '100vh' }}>
      <TopNav signOut={signOut} user={user} />
      <AppLayout
        // navigationHide={true}
        navigation={<SideNav />}
        navigationOpen={navigationOpen}
        onNavigationChange={({ detail }) => setNavigationOpen(detail.open)}
        content={
          <ErrorProvider>
            <AlertComponent />
            {children}
        </ErrorProvider>
        }
        toolsHide={true}
      />
    </div>
  );
}

export default MainLayout;